<div class="tunnel-page-container">
  <div class="card-marketing-container">
    <ng-casto-card-marketing [imageSrc]="placeholderImageSrc">
      <!-- <ng-template #headerTemplate>
      </ng-template>  -->
      <ng-template #bodyTemplate>
        Simplifiez vos travaux, gagnez du temps en choisissant la pose par Castorama et bénéficiez de la TVA réduite
        <sup>1</sup>.
      </ng-template>
    </ng-casto-card-marketing>
  </div>
  <div class="body-container">
    <ng-container #installationContainer></ng-container>
  </div>
  <div class="action-bar-container">
    <ng-casto-action-bar></ng-casto-action-bar>
  </div>
</div>
